<input
  type="text"
  class="form-control"
  [placeholder]="placeholder"
  [value]="formattedValue"
  (input)="onInput($event)" />
